import { render, staticRenderFns } from "./priceGroupModal.vue?vue&type=template&id=cd80cfe0&scoped=true"
import script from "./priceGroupModal.vue?vue&type=script&lang=js"
export * from "./priceGroupModal.vue?vue&type=script&lang=js"
import style0 from "./priceGroupModal.vue?vue&type=style&index=0&id=cd80cfe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd80cfe0",
  null
  
)

export default component.exports